
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';


const TrendTooltipMinMaxRow = ({ point, uom }) => {
    const { t: translate } = useTranslation();
    const { low: min, high: max } = point.point || {};
    const isRange = point?.series?.tooltipOptions?.isRange;
    const isDriveAirTemp = point?.isDriveAirTemp;
    let label;
    if (isRange === true && isDriveAirTemp) {
        label = `${translate('ABB.Powertrain.Frontend.rangeLabel')} (${translate('ABB.Powertrain.Frontend.rangeMinMax')})`;
    } else if (isRange === true) {
        label = `${translate('ABB.Powertrain.Frontend.rangeLabel')} (${translate('ABB.Powertrain.Frontend.rangePercentile')})`;
    } else {
        label = `${translate('ABB.Powertrain.Frontend.opTrendsLblMin')}/${translate('ABB.Powertrain.Frontend.opTrendsLblMax')}`;
    }
    return <>
        <span className='symbol' style={{ backgroundColor: point.color, opacity: '0.3' }} />
        <span className='d-inline-block m-1'>
            {label}: {min} / {max} {uom}
        </span>
    </>;
};

TrendTooltipMinMaxRow.propTypes = {
    point: PropTypes.shape({
        color: PropTypes.string,
        point: PropTypes.object
    }),

    uom: PropTypes.string
};


export default TrendTooltipMinMaxRow;
